module.exports = {
	"description": "Popovers hold supporting information or user controls.\nPopovers will float over page content.\nPlacement, scroll behavior and focus management can all be controlled to customize your implementation.\nPopovers can be toggled on a user action or a state change.",
	"methods": [
		{
			"name": "close",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "closeActions",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "focusTrigger",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		},
		{
			"name": "handleDocumentClick",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "handleDocumentKeydown",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "isClickOutsideComponent",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "isControlled",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		},
		{
			"name": "open",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "openActions",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "toggleOpenState",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		}
	],
	"props": {
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": true,
			"description": "Trigger for the Popover"
		},
		"content": {
			"flowType": {
				"name": "$FlowFixMe"
			},
			"required": true,
			"description": "Content of the Popover"
		},
		"disabled": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Disables the Popover"
		},
		"hasArrow": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Include an arrow on the Popover content pointing to the trigger",
			"defaultValue": {
				"value": "true",
				"computed": false
			}
		},
		"isOpen": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "For use with controlled components, in which the app manages Popover state"
		},
		"modifiers": {
			"flowType": {
				"name": "Object"
			},
			"required": false,
			"description": "Plugins that are used to alter behavior. See [PopperJS docs](https://popper.js.org/popper-documentation.html#modifiers) for options."
		},
		"onClose": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: SyntheticEvent<>) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "SyntheticEvent",
								"elements": [],
								"raw": "SyntheticEvent<>"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called when Popover is closed"
		},
		"onOpen": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: SyntheticEvent<>) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "SyntheticEvent",
								"elements": [],
								"raw": "SyntheticEvent<>"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called when Popover is opened"
		},
		"defaultIsOpen": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Open the Popover immediately upon initialization"
		},
		"getTriggerProps": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(props: Object, scope?: Object) => Object",
				"signature": {
					"arguments": [
						{
							"name": "props",
							"type": {
								"name": "Object"
							}
						},
						{
							"name": "scope",
							"type": {
								"name": "Object"
							}
						}
					],
					"return": {
						"name": "Object"
					}
				}
			},
			"required": false,
			"description": "Function that returns props to be applied to the trigger"
		},
		"placement": {
			"flowType": {
				"name": "union",
				"raw": "| 'auto'\n| 'auto-end'\n| 'auto-start'\n| 'bottom'\n| 'bottom-end'\n| 'bottom-start'\n| 'left'\n| 'left-end'\n| 'left-start'\n| 'right'\n| 'right-end'\n| 'right-start'\n| 'top'\n| 'top-end'\n| 'top-start'",
				"elements": [
					{
						"name": "literal",
						"value": "'auto'"
					},
					{
						"name": "literal",
						"value": "'auto-end'"
					},
					{
						"name": "literal",
						"value": "'auto-start'"
					},
					{
						"name": "literal",
						"value": "'bottom'"
					},
					{
						"name": "literal",
						"value": "'bottom-end'"
					},
					{
						"name": "literal",
						"value": "'bottom-start'"
					},
					{
						"name": "literal",
						"value": "'left'"
					},
					{
						"name": "literal",
						"value": "'left-end'"
					},
					{
						"name": "literal",
						"value": "'left-start'"
					},
					{
						"name": "literal",
						"value": "'right'"
					},
					{
						"name": "literal",
						"value": "'right-end'"
					},
					{
						"name": "literal",
						"value": "'right-start'"
					},
					{
						"name": "literal",
						"value": "'top'"
					},
					{
						"name": "literal",
						"value": "'top-end'"
					},
					{
						"name": "literal",
						"value": "'top-start'"
					}
				]
			},
			"required": false,
			"description": "Placement of the Popover",
			"defaultValue": {
				"value": "'bottom'",
				"computed": false
			}
		},
		"subtitle": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "Subtitle displayed under the title"
		},
		"title": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "Title of the Popover"
		},
		"triggerRef": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(node: ?React$Component<*, *>) => void",
				"signature": {
					"arguments": [
						{
							"name": "node",
							"type": {
								"name": "React$Component",
								"elements": [
									{
										"name": "unknown"
									},
									{
										"name": "unknown"
									}
								],
								"raw": "React$Component<*, *>",
								"nullable": true
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "@Private ref for the Popover trigger"
		},
		"wrapContent": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Display the content with default styles",
			"defaultValue": {
				"value": "true",
				"computed": false
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Popover/Popover.js
// module id = 1694
// module chunks = 0